export default {
    slug: 'automations',
    ability: 'automations',
    routes: [
        {
            path: 'automations',
            name: 'automation-list',
            component: () => import('@modules/Automations/Resources/js/pages/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'automation-preview',
                    component: () => import('@modules/Automations/Resources/js/pages/Preview.vue'),
                    redirect: { name: 'automation-overview' },
                    props: true,
                    children: [
                        {
                            path: '/organization/:org/automations/:id(\\d+)',
                            name: 'automation-overview',
                            component: () => import('@modules/Automations/Resources/js/pages/preview/Overview.vue'),
                            props: true
                        },
                        {
                            path: 'logs',
                            name: 'automation-logs',
                            component: () => import('@modules/Automations/Resources/js/pages/preview/Logs.vue'),
                            props: true
                        }
                    ]
                }
            ]
        },
        // Automation Builder (full page)
        {
            path: 'automations/new',
            name: 'automation-new',
            component: () => import('@modules/Automations/Resources/js/pages/Builder.vue')
        },
        {
            path: 'automations/:id(\\d+)/edit',
            name: 'automation-edit',
            component: () => import('@modules/Automations/Resources/js/pages/Builder.vue'),
            props: route => ({ id: route.params.id })
        }
    ],
    integrationRoutes: [
        {
            path: 'inbound-webhooks',
            name: 'settings-inbound-webhooks',
            component: () => import('@modules/Automations/Resources/js/pages/inbound-webhooks/Index.vue')
        },
        {
            path: 'inbound-webhooks/:webhookId(\\d+)',
            name: 'settings-inbound-webhook',
            component: () => import('@modules/Automations/Resources/js/pages/inbound-webhooks/Show.vue'),
            props: true
        }
    ],
    integrationTabs: () => [
        {
            title: i18n.t('Inbound webhooks'),
            icon: 'webhook',
            route: 'settings-inbound-webhooks',
            position: 10
        }
    ],
    nav: () => ({
        section: 'bottom',
        items: [
            {
                position: 1,
                title: i18n.t('Automations'),
                icon: 'robot-outline',
                to: { name: 'automation-list' }
            }
        ]
    })
};
